import { useEffect, useState } from "react";
import { api, apiErr } from "@/admin/api";
import { PageTitle, fmtDate } from "@/admin/ui";
import { Loader2 } from "lucide-react";

export default function Activity() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/activity").then(({ data }) => setItems(data)).catch((e) => { setItems([]); console.error(apiErr(e)); });
  }, []);

  return (
    <div data-testid="admin-activity">
      <PageTitle title="Activity Log" subtitle="A record of all admin actions" />
      <div className="bg-white rounded-2xl border border-bone p-6">
        {!items ? <div className="flex justify-center py-12"><Loader2 className="animate-spin text-terracotta" /></div>
          : items.length === 0 ? <p className="text-ink-soft text-sm">No activity recorded yet.</p>
          : (
            <ol className="relative border-l border-bone ml-2">
              {items.map((a) => (
                <li key={a.id} className="mb-6 ml-5">
                  <span className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full bg-terracotta" />
                  <p className="text-ink text-sm"><span className="font-medium">{a.user_name || a.user_email}</span> · {a.action.replace(/_/g, " ")}</p>
                  {a.detail && <p className="text-ink-soft text-xs mt-0.5">{a.detail}</p>}
                  <p className="text-ink-soft/70 text-xs mt-0.5">{fmtDate(a.created_at)} · {a.role}</p>
                </li>
              ))}
            </ol>
          )}
      </div>
    </div>
  );
}
